/**
 * Who a mass email goes to, as form fields, and what its preview says
 * about the class.
 *
 * A class send posts only class_ids; the server names each family's own
 * classes in their copy. It used to post the first class picked as
 * class_id too, on every send, and every family was then told the email
 * was about that one class.
 *
 * A program send can be narrowed to one area, and an area send to one
 * program: the club runs a program in places 150 miles apart. Each mode
 * keeps its own narrowing, so one picked under the other is never sent.
 */
export const recipientFields = ({
  recipientType,
  selectedClassIds,
  selectedProgramId,
  selectedAreaId,
  programAreaId,
  areaProgramId,
  customRecipient,
}) => {
  switch (recipientType) {
    case "class":
      return [["class_ids", JSON.stringify(selectedClassIds)]];
    case "program":
      return [
        ["program_id", selectedProgramId],
        ...(programAreaId ? [["area_id", programAreaId]] : []),
      ];
    case "area":
      return [
        ["area_id", selectedAreaId],
        ...(areaProgramId ? [["program_id", areaProgramId]] : []),
      ];
    case "custom":
      return customRecipient
        ? [["recipient_ids", JSON.stringify([customRecipient.id])]]
        : [];
    default:
      return [];
  }
};

/** The preview's "Regarding" text: the class, or a note that each family
 * sees only their own when several are picked. Null hides the line. */
export const regardingPreview = (pickedClasses) => {
  if (pickedClasses.length === 0) return null;
  if (pickedClasses.length === 1) return pickedClasses[0].name;
  return "each family sees only their own child's class";
};
